import { render, staticRenderFns } from "./SelectWeight.vue?vue&type=template&id=7ae4fca3"
import script from "./SelectWeight.vue?vue&type=script&lang=js"
export * from "./SelectWeight.vue?vue&type=script&lang=js"
import style0 from "./SelectWeight.vue?vue&type=style&index=0&id=7ae4fca3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports